import styled from "@emotion/styled";
//TODO: check if changing language is necessary to change class property name
export const CustomTableStyle = styled.div`
.data-import-table{
    min-height: 0px !important;
}
`